export enum DealsRoles {
  CREATOR = 'roles.dealsCreator',
  VIEWER = 'roles.dealsViewer',
  ASSIGNEE_VIEWER = 'roles.dealsAssigneeViewer',
  EDITOR = 'roles.dealsEditor',
  ASSIGNEE_EDITOR = 'roles.dealsAssigneeEditor',
  UNSHARE_DEAL_FILES = 'roles.dealsUnshareDealFiles',
  COMPLIANCE_FORM_VIEWER = 'roles.complianceFormViewer',
  COMPLIANCE_FORM_SUBMITTER = 'roles.complianceFormSubmitter',

  ARCHIVER = 'roles.dealsArchiver',
  ASSIGNEE_ARCHIVER = 'roles.dealsAssigneeArchiver',

  TEMPLATE_CREATOR = 'roles.dealsTemplateCreator',
  TEMPLATE_APPLIER = 'roles.dealsTemplateApplier',

  PAYMENT_OPTIONS_MANAGER = 'deals.invoicePaymentOptionsManager',
  PRICE_VISIBILITY_MANAGER = 'deals.invoicePriceVisibilityManager',
  PROFITABILITY_VIEWER = 'roles.dealProfitabilityViewer',
  REFERENCE_EDITOR = 'roles.dealsReferenceEditor',
  DESCRIPTION_EDITOR = 'roles.dealsDescriptionEditor',

  INTEGRATIONS_VIEWER = 'roles.integrationsViewer',

  BULK_EXPORTER = 'roles.dealsBulkExporter',

  CLIENT_PORTAL_PREVIEWER = 'roles.dealsClientPortalPreviewer',
}
